import React from "react";
import PropTypes from "prop-types";

import { faGripVertical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Icon } from "semantic-ui-react";

import "./ConditionsGroupViewLayout.css";

import { useBooleanState } from "hooks";
import { useDraggable } from "components/DragDrop";

import { useDragDropContext } from "scenes/Hubly/components/Workspace/components/WorkflowContainer/components/WorkflowEditor/hooks";

export function ConditionsGroupViewLayout({
  conditionDetails,
  itemType,
  disabled,
  popupMenu,
  children,
  withDraggable,
  showIcon,
  onClick,
}) {
  const { draggableProps, dragHandleProps } = useDraggable();

  const [isGroupHoverEnabled, enableGroupHover, disableGroupHover] =
    useBooleanState();
  const [{ isDragging, disabled: disableDnd, getCursor }] =
    useDragDropContext();

  return (
    <div
      className={`conditions-group-view ${
        disabled || !isGroupHoverEnabled || isDragging
          ? ""
          : "conditions_group_hover"
      }`}
      style={{ cursor: !disableDnd && isDragging ? "grabbing" : undefined }}
      data-test="conditions-group-view"
      data-show-icon={showIcon}
      onMouseEnter={enableGroupHover}
      onMouseLeave={disableGroupHover}
      onClick={onClick}
      {...(withDraggable ? draggableProps : {})}
    >
      <div
        className="drag-icon-column"
        data-test="drag-icon"
        onClick={(e) => {
          e.stopPropagation();
        }}
        {...(withDraggable ? dragHandleProps : {})}
      >
        {!disabled && (
          <FontAwesomeIcon
            className={`dark_grey_on_hover ${itemType}-drag-handle`}
            color="rgb(218, 218, 218)"
            icon={faGripVertical}
            style={{ marginLeft: "0.5em", cursor: getCursor() }}
          />
        )}
      </div>
      <div data-test="content-column" className="content-column">
        <div data-test="conditions-names-row" className="conditions-names-row">
          {showIcon && (
            <div
              style={{ marginLeft: "0.7em", width: 20, textAlign: "center" }}
            >
              <Icon name="filter" style={{ color: "#BBBBBB" }} />
            </div>
          )}
          <div
            data-test="condition-details"
            style={{ marginLeft: "0.4em", flexGrow: 1 }}
          >
            {conditionDetails}
          </div>
          <div data-test="condition-menu" style={{ marginLeft: "0.2em" }}>
            {popupMenu}
          </div>
        </div>
        <div
          className="items-container-row"
          data-test={`${itemType}-container`}
          onMouseEnter={disableGroupHover}
          onMouseLeave={enableGroupHover}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}

ConditionsGroupViewLayout.propTypes = {
  conditionDetails: PropTypes.node,
  disabled: PropTypes.bool,
  popupMenu: PropTypes.node,
  children: PropTypes.node,
  onClick: PropTypes.func,
  withDraggable: PropTypes.bool,
  itemType: PropTypes.string,
  showIcon: PropTypes.bool,
};

ConditionsGroupViewLayout.defaultProps = {
  conditionDetails: false,
  disabled: false,
  children: null,
  popupMenu: null,
  onClick: () => {},
  withDraggable: false,
  itemType: "task",
  showIcon: true,
};

export default ConditionsGroupViewLayout;
